import React, { Component } from "react";
import withFirebaseAuth from "react-with-firebase-auth";
import firebase from "firebase";
import "firebase/auth";
import "firebase/firestore";
import logo from "./logo.svg";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect
} from "react-router-dom";
import { Navbar } from "react-bootstrap";
import Home from "./Home";
import Landing from "./Landing";
// import Login from './Login';
// import Home from './Home';
// import Landing from './Landing';

var validator = require("email-validator");

// class App extends Component {
//   render() {
//     const {
//       user,
//       signOut,
//       signInWithGoogle,
//     } = this.props;

//     return (
//         <div style={styles.app}>
//           {/* <img src={logo} className="App-logo" alt="logo" /> */}
//           {/* {
//             user
//               ? <p>Hello, {user.displayName}</p>
//               : <p>Please sign in.</p>
//           } */}
//           {user ? <Home signOut={signOut} /> : <Landing signInWithGoogle={signInWithGoogle}/>}
//           {/* {
//             user
//               ? <button onClick={signOut}>Sign out</button>
//               : <button onClick={signInWithGoogle}>Sign in with Google</button>
//           } */}
//       </div>
//     );
//   }
// }
const config = {
  apiKey: "AIzaSyDpNYdcLIe6kIZb-xDh0e7Rct-HzdJ0kUU",
  authDomain: "stryve-29ff0.firebaseapp.com",
  databaseURL: "https://stryve-29ff0.firebaseio.com",
  projectId: "stryve-29ff0",
  storageBucket: "stryve-29ff0.appspot.com",
  messagingSenderId: "322396431201",
  appId: "1:322396431201:web:636cd558df259a6a585b20",
  measurementId: "G-6QZR1H7RCB"
};

firebase.initializeApp(config);

// <div style={styles.app}>
/* <img src={logo} className="App-logo" alt="logo" /> */
/* {
            user
              ? <p>Hello, {user.displayName}</p>
              : <p>Please sign in.</p>
          } */
/* {user ? <Home2 signOut={signOut} /> : <Landing2 signInWithGoogle={signInWithGoogle}/>} */
/* {
            user
              ? <button onClick={signOut}>Sign out</button>
              : <button onClick={signInWithGoogle}>Sign in with Google</button>
          } */
/* </div> */

function App({ user, signOut, signInWithGoogle }) {
  return (
    <Router>
      <div>
        {/* <Navbar style={{display: 'flex', flexDirection: 'row', alignItems: 'center',}}>
            <Navbar.Brand>
                <div style={{height: 40, width: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                    <img
                        src={require('./assets/menu.png')} 
                        style={{height: 30}}
                    />
                </div>
            </Navbar.Brand>
            <Navbar.Brand>
                <div style={{height: 40, width: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                    <img
                        src={require('./assets/back.png')} 
                        style={{height: 30}}
                    />
                </div>
            </Navbar.Brand>
            <Navbar.Brand>
                <img
                    src={require('./assets/lightning.png')} 
                    style={{height: 40, width: 40}}
                />
            </Navbar.Brand>
        </Navbar> */}
        <Landing />
        {/* <Switch>
            <Route path="/login">
              {!user ? <Login signInWithGoogle={signInWithGoogle} /> : <Redirect to="/" />}
            </Route>
            <Route path="/">
              {user ? <Home signOut={signOut} /> : <Landing />}
            </Route>
          </Switch> */}
      </div>
    </Router>
  );
}

function Login({ signInWithGoogle }) {
  return (
    <div>
      <p>Login</p>
      <button onClick={signInWithGoogle}>Sign in with Google</button>
    </div>
  );
}

const firebaseAppAuth = firebase.auth();

const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider()
};

export function handleSubmitEmail(email, setSubmitted) {
  // alert('A name was submitted: ' + value);
  // if email is valid
  if (!email) {
    return;
  }
  if (!validator.validate(email)) {
    alert("Please enter a valid email.");
    return;
  }
  firebase
    .firestore()
    .collection("Emails")
    .doc(email)
    .set({ requested: true })
    .then(response => {
      setSubmitted(true);
    })
    .catch(err => {
      console.log(err);
    });
  // event.preventDefault();
}

const styles = {
  app: {
    display: "flex",
    flexDirection: "column",
    flex: 1
  }
};

export default withFirebaseAuth({
  providers,
  firebaseAppAuth
})(App);
